import { render, staticRenderFns } from "./learning_resources_slider.vue?vue&type=template&id=5e20370f&"
import script from "./learning_resources_slider.vue?vue&type=script&lang=js&"
export * from "./learning_resources_slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports